import React from 'react';
import ReactGA from "react-ga4";
// Zustand
import { useStore } from "../../zustand";
import { fetchKlaviyoOptions } from "../../utility/fetchData";
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
// Icons
import { ReactComponent as IconStar } from "../../assets/icons/star.svg";
import { ReactComponent as PlayButton } from "../../assets/icons/playButton.svg";
import { ReactComponent as KeenLogo } from "../../assets/logos/keen_logo.svg";
// Styles
import { makeStyles } from '@material-ui/core/styles';
// Components
import useYoutubeScript from '../BillboardUI/useYoutubeScript';
// import ViewSpaceBtn from '../ButtonsUI/ViewSpaceBtn';
//import BtnLaunchAR from '../ButtonsUI/BtnLaunchAR';
// import ARLaunch from '../ButtonsUI/ARLaunch';
import useScript from '../BillboardUI/useScript';
// import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    header_billboards: {
        display: 'flex',
        justifyContent: 'flex-start',
        order: 0,
        width: '100%',
        position: 'relative',
        borderTop: '2rem solid',
        borderColor: props => props.viewer_button.button_color,
        borderColor: '#ffdd02',
        '&.unbranded': {
            borderColor: '#ffdd02',
        },
        [theme.breakpoints.down('sm')]: {
            order: 2,
            justifyContent: 'center',
            flexWrap: 'wrap',
            borderTopWidth: '0.75rem',
            position: 'relative',
            zIndex: 2,
            background: '#fff',
            '&.video_active': {
                zIndex: 4,
                position: 'static',
            },
            '&.unbranded': {
                background: '#fefefe',
                boxShadow: '0px 0px 2px 0px rgb(0,0,0,0.15)',
                borderTop: '0.75rem solid #ffdd02',
            },
            '.video_tab_active &': {
                marginBottom: 320,
            },
        },
        [theme.breakpoints.up('md')]: {
            padding: '0.5rem 1rem',
            position: 'absolute',
            minHeight: 70,
            '.has_no_options &': {
                position: 'relative',
                minHeight: 0,
            },
            '.has_no_pois &': {
                position: 'relative',
                minHeight: 0,
            }
        },
    },  
    header_logo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.5em 0 0 1em',
        '& img': {
            maxHeight: 70,
        },
        '& svg': {
            height: 60,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
            '& img': {
                maxHeight: 35,
            },
            '& svg': {
                height: 32,
            },
        },
    },
    product_info: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        // padding: '1rem 1rem 0 1rem', TO DO
        paddingTop: '2rem',
        paddingLeft: '1rem',
        paddingRight: '1rem',
        '& h1': {
            //whiteSpace: 'nowrap',
            overflow: 'hidden',
            //textOverflow: 'ellipsis', TO DO
            //maxWidth: 450, TO DO
            textOverflow: 'ellipsis',
            maxWidth: 350,
            fontWeight: 600,
            fontSize: '1.25rem',
            margin: 0,
            lineHeight: 1.15,
            //marginBottom: '0.125rem', TO DO
            marginBottom: '0.25rem',
            [theme.breakpoints.down('sm')]: {
                maxWidth: 450,
            },
        },
        '& span': {
            // color: props => props.viewer_button.button_color,
            // fontWeight: 600,
            // lineHeight: 1,
            // fontSize: '1.15rem',
        },
        '.unbranded &': {
            paddingTop: '1.25rem',
            paddingBottom: '0.75rem',
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    variant_price: {
        color: props => props.viewer_button.button_color,
        fontWeight: 600,
        lineHeight: 1,
        fontSize: '1.15rem',
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    product_info_bottom: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '.has_tabs &': {
            marginTop: 8,
        },
    },
    reviews_bottom_line: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap',
        marginRight: 'auto', 
    },
    icon_star: {
        marginRight: '0.075rem',
        width: '1rem',
        '& .b': {
            strokeWidth: '20px',
        },
        [theme.breakpoints.up('md')]: {
            width: '1.25rem',
        },
    },
    full_star: {
        '& .b': {
            fill: '#ede80b',
            stroke: '#9fa1a4',
        },
    },
    empty_star: {
        '& .b': {
            fill: 'none',
            stroke: '#9fa1a4',
        },
    },
    review_count: {
        fontSize: '0.875rem !important',
        marginLeft: 6,
        marginTop: '0.25rem',
        color: 'rgba(0,0,0,0.875) !important',
        [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
        },
    },
    product_sku: {
        display: 'inline-flex',
        color: '#797979',
        fontSize: '0.875rem',
        marginLeft: 'auto',
        marginTop: '0.25rem',
        [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
        }, 
    },
    video_thumb: {
        position: 'absolute',
        top: 0,
        transform: 'translateY(-100%)',
        left: 0,
        width: '100%',
        opacity: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 340,
        transition: 'opacity 0.5s linear',
        '& img': {
            display: 'block',
            maxWidth: '100%',
            maxHeight: 320,
        },
        '.video_active &': {
            background: '#fff',
            transform: 'translateY(0)',
            top: 150,
            opacity: 1,
        },
        '&:hover ${play_button}': {
            opacity: 1,
        },
        [theme.breakpoints.up('md')]: {
            left: '12%',
            width: '55%',
            height: '65vh',
            '& img': {
                maxHeight: 'none',
            },
        },
    },
    play_button: {
        position: 'absolute',
        width: 64,
        top: 'calc(50% - 32px)',
        left: 'calc(50% - 32px)',
        opacity: 0.9,
        transition: 'opacity 0.2s ease',
    },
    video_container: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        opacity: 0,
        backgroundColor: 'rgba(0,0,0,0.9)',
        transition: 'all 0.5s linear',
        padding: '0 2.5% 0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& iframe': {
            display: 'block',
            height: 0,
        },
        '&.active': {
            opacity: '1',
            height: '100%',
            position: 'fixed',
            zIndex: 9,
        },
        '&.active iframe': {
            height: 270,
        },
        [theme.breakpoints.up('sm')]: {
            padding: '0 5% 0',
            '&.active iframe': {
                height: '80vh',
            },
        },
    },
    video_close: {
        alignSelf: 'flex-end',
        color: '#fff',
        fontSize: '2.5rem',
        lineHeight: 1,
        cursor: 'pointer',
        marginTop: -40,
        '&:after': {
            display: 'inline-block',
            content: `'\\00d7'`, /* This will render the 'X' */
        },
    },
    product_tag: {
        background: '#000',
        color: '#fff',
        lineHeight: 1,
        fontSize: '0.8rem',
        padding: '0.3rem 0.75rem',
        marginBottom: '0.5rem',
        textTransform: 'uppercase',
        alignSelf: 'flex-start',
    },
}));

export default function HeaderBillboards() {
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    const { dynamic_text_settings, cLogo, klaviyo_id, ga_id, tabs_enabled } = useStore.getState().store_settings;
    const reviews = useStore.getState().reviews;
    const classes = useStyles(dynamic_text_settings);
    const { active_tab, video_active } = useStore(state => state.scene_controls);
    // const { intent, target } = useStore.getState().hrx;
    var headerClass = '';
    var video_id = vList[variant_id].youtube_url;
    const videoModal = React.useRef();

    if (active_tab === 0) {
        headerClass = 'video_active';
    }

    if(reviews.response.reviews.length > 0) {
        headerClass += ' unbranded';
    }

    const [loaded, error] = useYoutubeScript("sample-youtube");
    const isPlayerReady = React.useRef(false);
    const player = React.useRef(null);
    const isPlayerAlreadySet = player && player.current;
    const hasYoutubeInWindow = typeof window.YT === "object" && window.YT.Player;

    const video_thumb = 'https://img.youtube.com/vi/'+video_id+'/hqdefault.jpg';
    const klaviyo_url = '//static.klaviyo.com/onsite/js/klaviyo.js?company_id='+klaviyo_id;

    const _buildKlaviyoData = (klaviyo_id, vList, variant_id) => {
        var html = "var _learnq = _learnq || []; _learnq.push(['track', 'Viewed levAR Spotlight', {'ActivationType': 'levAR Spotlight', 'ProductName': '"+vList[variant_id].title+"', 'ProductID': '"+vList[variant_id].product_id+"', 'VariantName': '"+vList[variant_id].subTitle+"', 'VariantID': '"+variant_id+"', 'Price': '"+vList[variant_id].price+"', 'URL': '"+window.location.href+"' }]);";
        // return html;
        // var _learnq = _learnq || [];
        // _learnq.push(["track", "Viewed levAR Spotlight", {
        //     "ActivationType": "levAR Spotlight",
        //     "ProductName": vList[variant_id].title,
        //     "ProductID": vList[variant_id].product_id,
        //     "VariantName": vList[variant_id].subTitle,
        //     "VariantID": variant_id,
        //     "Price": vList[variant_id].price,
        //     "URL": window.location.href
        // }]);

        var klaviyo_data = {
            "token": klaviyo_id,
            "event": "Viewed levAR Spotlight",
            // "customer_properties": {
            //     "$email": "abraham.lincoln@klaviyo.com"
            // },
            "customer_properties": null,
            // "properties": {
            //    "ActivationType": "levAR Spotlight",
            //     "ProductName": vList[variant_id].title,
            //     "ProductID": vList[variant_id].product_id,
            //     "VariantName": vList[variant_id].subTitle,
            //     "VariantID": variant_id,
            //     "Price": vList[variant_id].price,
            //     "URL": window.location.href
            // }
            "properties": null
        }

        fetchKlaviyoOptions(klaviyo_data);

        return html;

        // return _learnq;
    }

    useScript((klaviyo_id ? klaviyo_url : null), null, true);
    useScript(null, (klaviyo_id ? _buildKlaviyoData(klaviyo_id, vList, variant_id) : null), false);

    React.useEffect(() => {
        if (ga_id) {
            ReactGA.initialize(ga_id);
            ReactGA.send("pageview");
        }
        const playerObject = player.current;
        return () => playerObject && playerObject.destroy && playerObject.destroy();
    }, [ga_id, video_active]);

    React.useEffect(() => {
        if (loaded) {
            if (!isPlayerAlreadySet && hasYoutubeInWindow) {
                player.current = new window.YT.Player("youtube_video_player", {
                    videoId: video_id,
                    width: '100%',
                    height: 300,
                    playerVars: getPlayerParameters(),
                    events: {
                        onReady: onPlayerReady
                    }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loaded]);

    if (isPlayerAlreadySet) {
        if (videoModal.current.classList.contains('active')) {
            setTimeout(function(){
                player.current.playVideo && player.current.playVideo();
            }, 500);
        } else {
            player.current.pauseVideo && player.current.pauseVideo();
        }
      }

    if (!loaded || error) {
        return <div>Loading...</div>;
    }

    const getPlayerParameters = () => {
        return {
            enablejsapi: 1,
            playsinline: 1, //default smallscreen
            fs: 1, // fullscreen
            controls: 1, // show controls
            rel: 0,
            modestbranding: 0,
            iv_load_policy: 3,
            showinfo: 1,
            widget_referrer: window.location.href,
            origin: window.location.href
        };
    };

    const onPlayerReady = () => {
        if (isPlayerReady && !!isPlayerReady.current) {
            return;
        }
        // its important to mute the video before playing since browser does not allow autoplay
        // player.current.mute && player.current.mute();
        if (videoModal.current.classList.contains('active') && player.current.playVideo) {
            setTimeout(function(){
                player.current.playVideo();
            }, 500);
        }
        isPlayerReady.current = true;
    };

    const openModal = async () => {
        videoModal.current.classList.add('active')
        player.current.playVideo();
        await sendAnalyticsData({ event_type: 'video_player_open' });
        return false;
    };

    const closeModal = async () => {
        videoModal.current.classList.remove('active')
        player.current.pauseVideo();
        return false;
    };

    // const _handleTabSelect = (targetTab) => {
    //   //setState({ tab: targetTab }) // Update tab state
    //   useStore.setState(state => ({ 
    //       scene_controls: { 
    //           ...state.scene_controls,
    //           active_tab: targetTab
    //       }
    //   }));
    //   return false;
    // }

    const _displayStarRating = (score) => {
        let content = [];
        for (let i = 0; i < score; i++) {
          content.push(<IconStar className={`${classes.icon_star} ${classes.full_star}`} key={i} />);
        }
        if (score < 5) {
            for (let n = 0; n < (5 - score); n++) {
              content.push(<IconStar className={`${classes.icon_star} ${classes.empty_star}`} key={n} />);
            }
        }
        return content;
    }

    const _displayLogo = (tabs_enabled) => {
        if (cLogo &! tabs_enabled) {
            return (
                <div className={classes.header_logo}>
                    <img src={cLogo} alt="logo" title="logo" />
                </div>
            );
        }
        else {
            return (
                <div className={classes.header_logo}>
                    <KeenLogo alt="logo" title="logo" />
                </div>
            );
        }
    }
    
    return (
        <div className={`${classes.header_billboards} ${headerClass}`}>
            {_displayLogo(tabs_enabled)}
            <div className={classes.product_info}>
                <div className={classes.product_tag}>BestSeller</div>
                <h1 className={classes.variant_title}>{vList[variant_id].title}</h1>
                <span className={classes.variant_price}>{vList[variant_id].price ? vList[variant_id].price : '$165.00'}</span>
                <div className={classes.product_info_bottom}>
                    <div className={classes.reviews_bottom_line}>
                        {_displayStarRating(Math.round(reviews.response.bottomline.average_score))}
                        <span className={classes.review_count}>{reviews.response.bottomline.total_review}</span>
                    </div>
                    <span className={classes.product_sku}>Style #1002375</span>
                    {/*<ARLaunch design="tabs" />*/}
                </div>
            </div>
            <div className={classes.video_thumb}>
                <img src={video_thumb} alt="Play Video" title="Play Video" onClick={() => openModal()} />
                <PlayButton className={classes.play_button} onClick={() => openModal()} />
            </div>
            <div className={classes.video_container} ref={videoModal} onClick={() => closeModal()}>
                <div className={classes.video_close} onClick={() => closeModal()} />
                <div id="youtube_video_player"> </div>
                {/*<iframe id="video-player" width="100%" src="https://www.youtube.com/embed/o6rc1PtSTdo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>*/}
            </div>
        </div>
    );
}

// {/* <div className={clsx({
//             [classes.option_value] : true,
//             [classes.option_swatch] : true,
//             [classes.active_option] : value.label === current_name_value
//         })} */}